/**
 * Responsive Card Carousel (.rcc)
 *
 * Initialises Swiper below a configurable breakpoint and destroys it above.
 * Each .rcc instance can set its own activation breakpoint via
 * data-rcc-breakpoint (defaults to 767).
 *
 * When breakpoint > 767, Swiper uses fixed slidesPerView with responsive
 * breakpoints (1 → 2 → 3) instead of the default centred "auto" mode.
 */
$(function () {

	var CAROUSEL_SELECTOR = '.rcc__carousel';
	var SCROLLBAR_SELECTOR = '.rcc__scrollbar';
	var DEFAULT_BREAKPOINT = 767;

	$('.rcc').each(function () {
		var $rcc = $(this);
		var $carousel = $rcc.find(CAROUSEL_SELECTOR);
		if (!$carousel.length) return;

		var breakpoint = parseInt($rcc.data('rcc-breakpoint')) || DEFAULT_BREAKPOINT;
		var swiperInstance = null;

		// Build Swiper config
		var config = {
			spaceBetween: 30,
			slidesPerView: 'auto',
			centeredSlides: true,
			snapOnRelease: true,
			scrollbar: {
				el: $carousel.find(SCROLLBAR_SELECTOR)[0],
				hide: false
			}
		};

		// For carousels that are active above the default mobile breakpoint,
		// use fixed slidesPerView with responsive Swiper breakpoints
		if (breakpoint > DEFAULT_BREAKPOINT) {
			config.slidesPerView = 1;
			config.breakpoints = {
				768: {
					slidesPerView: 2,
					centeredSlides: false
				},
				1200: {
					slidesPerView: 3,
					centeredSlides: false
				}
			};
		}

		function init() {
			if (!swiperInstance) {
				swiperInstance = new Swiper($carousel[0], config);
			}
		}

		function destroy() {
			if (swiperInstance) {
				swiperInstance.destroy(true, true);
				swiperInstance = null;
			}
		}

		function handleChange(mql) {
			if (mql.matches) {
				init();
			} else {
				destroy();
			}
		}

		var mql = window.matchMedia('(max-width: ' + breakpoint + 'px)');
		handleChange(mql);

		if (mql.addEventListener) {
			mql.addEventListener('change', handleChange);
		} else {
			mql.addListener(handleChange);
		}
	});
});

//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIiwic291cmNlcyI6WyJyZXNwb25zaXZlLWNhcmQtY2Fyb3VzZWwuanMiXSwiZmlsZSI6InJlc3BvbnNpdmUtY2FyZC1jYXJvdXNlbC5qcyJ9
